import React, { useEffect } from 'react';
import { useStore } from '../../../../../../stores/root';
import { observer } from 'mobx-react';

// assets

// services

// props
import { IIncomeInvoiceResourceShortProps } from '../../../../../../props/finance/incomes/invoices/invoice';
import { IIncomeInvoiceItemResourceShortProps } from '../../../../../../props/finance/incomes/invoices/item';

// components
import { DetailsList, IColumn, SelectionMode, Stack } from '@fluentui/react';
import Text from '../../../../../typography/text';
import GeneralService from '../../../../../../services/general';
import { IIncomeInvoiceOrderItemResourceShortProps } from '../../../../../../props/finance/incomes/invoices/orderitem';
import Label from '../../../../../typography/label';

type IncomeInvoiceOrderItemsProps = {
    invoice: IIncomeInvoiceResourceShortProps;
}

const IncomeInvoiceOrderItems: React.FC<IncomeInvoiceOrderItemsProps> = observer((props: IncomeInvoiceOrderItemsProps) => {
    const { banner, user } = useStore();
    const { invoice } = props;

    const columns: IColumn[] = [
        {
            key: "no",
            name: "No.",
            minWidth: 40,
            maxWidth: 40,
            onRender: (item: IIncomeInvoiceOrderItemResourceShortProps, idx?: number) => {
                return <Stack styles={{ root: { padding: 4 } }}>
                    <Text size={'small'}>{(idx || 0) + 1}</Text>
                </Stack>
            }
        },
        {
            key: "name",
            name: "Item Name",
            minWidth: 200,
            maxWidth: 200,
            isMultiline: true,
            onRender: (item: IIncomeInvoiceOrderItemResourceShortProps, idx?: number) => {
                return <Stack styles={{ root: { padding: 4 } }}>
                    {item.container ? <>
                        <Label size={'small'}>Container {item.container.containerNumber || item.container.name}</Label>
                        {(item.container.sealNumber || "").trim() !== "" ? <Text size={'small'}>Seal number: {item.container.sealNumber}</Text> : null}
                    </> : null}
                    {item.goods ? <>
                        <Label size={'small'}>{item.goods.goods.name} ({item.goods.quantityAmount}{item.goods.goods.quantityUnit})</Label>
                    </> : null}
                    {item.truck ? <>
                        {item.truck.vehicleRegistrationNumber && !item.truck.truck ? <Label size={'small'}>Truck {item.truck.vehicleRegistrationNumber}</Label> : null}
                        {item.truck.truck && !item.truck.vehicleRegistrationNumber ? <Label size={'small'}>Truck {item.truck.truck.registrationNumber}</Label> : null}
                        {!item.truck.vehicleRegistrationNumber && !item.truck.truck ? <Label size={'small'}>Truck</Label> : null}
                    </> : null}
                    {item.addon ? <>
                        <Label size={'small'}>{item.addon.name}</Label>
                    </> : null}
                </Stack>
            }
        },
        {
            key: "notes",
            name: "Notes",
            minWidth: 100,
            isMultiline: true,
            onRender: (item: IIncomeInvoiceOrderItemResourceShortProps, idx?: number) => {
                const details = item.container || item.goods || item.truck || item.addon;

                return <Stack>
                    <Text size={'small'}>{details?.notes || ""}</Text>
                </Stack>
            }
        },
        {
            key: "totalPrice",
            name: "Total Price",
            minWidth: 200,
            maxWidth: 200,
            onRender: (item: IIncomeInvoiceOrderItemResourceShortProps, idx?: number) => {
                const details = item.container || item.goods || item.truck || item.addon;

                return <Stack>
                    <Text size={'small'}>Rp. {GeneralService.getNumberWithSeparator(details?.totalPrice || "0")}</Text>
                </Stack>
            }
        }
    ]

    useEffect(() => {
    }, []);

    return <Stack>
        <DetailsList items={invoice.orderItems || []}
            columns={columns}
            selectionMode={SelectionMode.none}
            compact />
    </Stack>
});

export default IncomeInvoiceOrderItems;
